const HomeIcon = ({ width = '32', height = '32', fill = '#fff' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.6964 10.7701C24.6964 12.4895 24.0948 14.1604 23.3211 15.1718C20.9528 9.58262 16.0637 6.29347 11.8945 6.29347C10.3353 6.29347 9.08872 6.58377 8.21126 6.87012C10.0016 5.34114 12.6498 4 15.9849 4C21.4178 4 24.6964 7.26682 24.6964 10.7701Z"
        fill={fill}
      />
      <path
        d="M7.3036 21.2299C7.3036 19.5118 7.9052 17.8396 8.67888 16.8295C11.0472 22.4187 15.9363 25.7065 20.1055 25.7065C21.6647 25.7065 22.9113 25.4176 23.7874 25.1312C21.9984 26.6589 19.3502 28 16.0151 28C10.5822 28 7.3036 24.7332 7.3036 21.2299Z"
        fill={fill}
      />
      <path
        d="M10.7701 7.30359C12.4882 7.30359 14.1604 7.90521 15.1705 8.6802C9.5813 11.0485 6.29347 15.9376 6.29347 20.1055C6.29347 21.6647 6.58245 22.9126 6.86881 23.7874C5.34114 21.9984 4 19.3515 4 16.0164C4 10.5822 7.26813 7.30359 10.7701 7.30359Z"
        fill={fill}
      />
      <path
        d="M16.8282 23.3211C22.4187 20.9528 25.7065 16.0637 25.7065 11.8945C25.7065 10.3353 25.4162 9.08741 25.1312 8.21258C26.6575 10.0016 28 12.6498 28 15.9862C28 21.4191 24.7332 24.6977 21.2299 24.6977C19.5118 24.6977 17.8383 24.0948 16.8282 23.3211Z"
        fill={fill}
      />
    </svg>
  );
};
//#DA271C
export default HomeIcon;
